import { Link } from "react-router-dom";


const CollectionCard2 = ({item, className}) => {
    
    return(
        <Link to = {`/collection/${item.name}`} 
            className={`card_animation collection_card2 auction_card flex flex-col items-center justify-center rounded-[8px] 
                border-[1px] border-gray-700 ${className}`}>
            <div className="image_box h-full max-h-[400px]">
                <img src = {item.image} alt = {item.name} className = "w-full h-full object-cover image_content rounded-t-[10px]" />
            </div>

            <div className="flex flex-col w-full p-3 sm:p-5">
                <h3 className="text-center text-base mb-1">{item.name}</h3>  
                <p className="text-center text-base mb-3">by <span className="text-[#DE00FF]">{item.creator}</span></p>    
                
                <p className="text-center text-sm sm:text-base text-[#BCBCBC] max-h-[90px] overflow-hidden">
                    {item.description}    
                </p>  
                
            </div>
            

        </Link>
    )
}

export default CollectionCard2;